<box class="result-page-container">
  <box class="result-status">
    <box class="status-icon-wrapper">

      <ng-container [ngSwitch]="state.resultData.currentStage?state.resultData.currentStage:'Success'">

        <ng-container *ngSwitchCase="'SuccessEnd'">
          <ng-container *ngIf="state.resultData.currentStage == 'SuccessEnd'">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon-success" width="60" height="60" viewBox="0 0 60 60">
              <g id="ic-ok" transform="translate(0 -12)">
                <g id="ok" transform="translate(0 12)">
                  <g id="Oval_55" data-name="Oval 55">
                    <g id="Oval_55-2" data-name="Oval 55" fill="#4BB543" stroke="#4BB543" stroke-miterlimit="10"
                      stroke-width="2">
                      <circle cx="30" cy="30" r="30" stroke="none" />
                      <circle cx="30" cy="30" r="29" fill="none" />
                    </g>
                    <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
                  </g>
                  <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0"
                    transform="translate(18.622 21.889)" fill="none" stroke="#fff" stroke-linecap="round"
                    stroke-linejoin="round" stroke-miterlimit="10" stroke-width="4" />
                </g>
              </g>
            </svg>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'FailureEnd'">
          <i _ngcontent-wsp-c4="" class="icon-spacing failur-icon-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon-failure" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
              <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
                <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                  <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                    fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
                  <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                    fill="none" stroke="#F40000" stroke-linecap="round" stroke-width="4"></line>
                </g>
              </g>
            </svg>
          </i>
        </ng-container>

        <ng-container *ngSwitchCase="'Warning'">
          <i _ngcontent-wsp-c4="" class="icon-spacing" style="
              width: 60px;
              height: 60px;
              background-color: #ff0000;
              border-radius: 50%;
              line-height: 60px;
            ">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon-warning" width="17.657" height="17.657" viewBox="0 0 17.657 17.657">
              <g id="Group_11535" data-name="Group 11535" transform="translate(-5694.015 -487.515)">
                <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                  <line id="Line_325" data-name="Line 325" x2="12" y2="12" transform="translate(5672.304 487.804)"
                    fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
                  <line id="Line_326" data-name="Line 326" x1="12" y2="12" transform="translate(5672.304 487.804)"
                    fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="4"></line>
                </g>
              </g>
            </svg>
          </i>
        </ng-container>
      </ng-container>
    </box>
  </box>

  <box class="result-body">
    <ng-container *ngIf="state.resultData.currentStage == 'SuccessEnd'; else failureTemplate">
      <h2>Successful</h2>
    </ng-container>
    <ng-template #failureTemplate>
      <h2>Something Went Wrong</h2>
    </ng-template>
    <p class="result-sub-title">{{ state.resultData.message }}</p>

    <box class="result-data-container">
      <ng-container *ngIf="transfersResultPageService.scheduleId && !state?.tranInternationalRefNo?.split('-')?.[4]; else showProcessId">
        <box class="result-data-item"><span class="result-data-item-key">Ref No#</span><span class="result-data-item-colon">:</span><span class="result-data-item-value"> <span class="result-data-item-value-data">{{transfersResultPageService.scheduleId.substring(transfersResultPageService.scheduleId.length-6) }}</span></span></box>
      </ng-container>
      <ng-template #showProcessId>
       <!--asdfd--> 
<box class="result-data-item" *ngIf="beneficiariesService?.internationalTranDetails?.transferService =='TRANINTERNATIONAL' && state?.tranInternationalRefNo?.split('-')?.[4]"><span class="result-data-item-key">Ref No#</span><span class="result-data-item-colon">:</span><span class="result-data-item-value"> <span class="result-data-item-value-data">{{state.tranInternationalRefNo.split('-')[4] }}</span></span></box>

        <box class="result-data-item" *ngIf="state?.resultData?.processId && !state?.tranInternationalRefNo?.split('-')?.[4]"><span class="result-data-item-key">Ref No#</span><span class="result-data-item-colon">:</span><span class="result-data-item-value"> <span class="result-data-item-value-data">{{state.resultData.processId.substring(state.resultData.processId.length-6) }}</span></span></box>
      </ng-template>
       <box class="result-data-item" *ngIf="state.resultData.currentDateTime"><span class="result-data-item-key">Date & Time</span><span class="result-data-item-colon">:</span><span class="result-data-item-value"> <span class="result-data-item-value-data">{{state.resultData.currentDateTime }}</span></span></box>
      <ng-container
        *ngIf="transfersResultPageService?.resultSubmittedData?.length>0">
        <ng-container *ngFor="let item of transfersResultPageService?.resultSubmittedData">
          <box class="result-data-item" ><span class="result-data-item-key">{{ item.key }}</span><span class="result-data-item-colon">:</span><span class="result-data-item-value"> <span class="result-data-item-value-data">{{ item.value }} </span></span></box>
        </ng-container>
<!-- 2Z6 -->
<ng-container *ngIf="this.state.hideDownload">
<ng-container *ngIf="transfersResultPageService.scheduleId; else showProcessId">
            <div class="info-icon" (click)="_helper.downloadTransferReceipt( transfersResultPageService.scheduleId,state.resultData.currentDateTime)" >
              <img src="./assets/images/download.gif" alt="loading..."
                />
  </div>
</ng-container>
<ng-template #showProcessId>
            <div class="info-icon" (click)="_helper.downloadTransferReceipt( state.resultData.processId,state.resultData.currentDateTime)" >
              <img src="./assets/images/download.gif" alt="loading..."
                />
  </div>
</ng-template>

      </ng-container>
    </ng-container>


    </box>

  </box>
  <ng-container *ngIf="_processShellService.resultIconData">
    <box *ngFor="let data of _processShellService.resultIconData" class="icon-container">
      <span clickable *ngIf="data?.icon == 'favourite' && state.favouriteEnable" (click)="formHelper.iconClick(data)">Save As Favourite</span>
    </box>
    <!-- 2Z6 -->
    <!-- <div class="info-icon">
		<img
		  src="./assets/images/download.gif"
		  alt="loading..."
		  (click)="_helper.downloadTransferReceipt( state.resultData.processId,state.resultData.currentDateTime)"
		/>
	  </div> -->
  </ng-container>

  <footer class="result-actions-footer-grp">
    <button type="button" class="button-common button40" (click)="_helper.onClose()">
      <span>{{state.closeBtnLable}}</span>
    </button>
  </footer>
</box>
